/** Non-secret identity verified by the Shopify API; token rotation must not change a bootstrap's principal. */
import * as z from 'zod';
export const SHOPIFY_SESSION_IDENTITY_HEADER = 'X-TestFeed-Shopify-Session-Identity';
export const SHOPIFY_EXPECTED_SESSION_IDENTITY_HEADER = 'X-TestFeed-Expected-Shopify-Session-Identity';
export const SHOPIFY_SESSION_RETRY_HEADER = 'X-Shopify-Retry-Invalid-Session-Request';
/**
 * The signed, shop-bound TestFeed account pass (`testfeed-account.ts`). The embedded app sends the latest one it holds on
 * every request from its single fetch choke point, and stores any new one a response carries. A valid pass stands in for a
 * fresh Web account check on account-only routes; saving or spending ignores it and checks Web again.
 */
export const SHOPIFY_ACCOUNT_PASS_HEADER = 'X-TestFeed-Account-Pass';
export const shopifySessionIdentitySchema = z.object({
    shopDomain: z.string().regex(/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/),
    userId: z.string().min(1),
    sessionId: z.string().min(1),
});
export function sameShopifySessionIdentity(left, right) {
    return left.shopDomain === right.shopDomain && left.userId === right.userId && left.sessionId === right.sessionId;
}
/** Only server-verified response metadata is accepted; never decode a browser JWT to establish authority. */
export function readShopifySessionIdentity(headers) {
    const value = headers.get(SHOPIFY_SESSION_IDENTITY_HEADER);
    if (!value)
        throw new Error('Shopify authenticated session identity is missing.');
    return shopifySessionIdentitySchema.parse(JSON.parse(decodeURIComponent(value)));
}
//# sourceMappingURL=shopify-session-identity.js.map